import React, { useState } from 'react';
import { toast } from 'react-toastify';
import OverlayLoading from '../components/common/overlay-loading';
import Api from '../api/api';
import { useNavigate } from 'react-router-dom';

const ResetPassword = props => {
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState('');
    const [pass, setPass] = useState('');
    const [pass1, setPass1] = useState('');
    const [pass2, setPass2] = useState('');
    const navigate = useNavigate();

    const resetPassword = async (event) => {
        event.preventDefault();

        setLoading(true)
        if (pass1 !== pass2) {
            toast.error(`Error - The passwords do not match`);
        } else {
            let req = await Api.post('auth/password-reset', {
                username: user,
                lastPassword: pass,
                newPassword: pass1,
            });
            if (!req.error) {
                navigate('/login');
            }
        }
        setLoading(false)
    }

    return <div>
        <OverlayLoading show={loading} />
        <div className="page-wrapper">
            <div className="container-fluid p-0">
                {/* <!-- login page start--> */}
                <div className="authentication-main" style={{
                    background: '#0A1C2C'
                }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="auth-innerright">
                                <div className="authentication-box">
                                    <div className="card mt-4">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <h4>{'Reset your password'}</h4>
                                            </div>
                                            <form className="theme-form">
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0">Username</label>
                                                    <input className="form-control"
                                                        type="text"
                                                        name="user"
                                                        value={user}
                                                        onChange={e => setUser(e.target.value)}
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label">{'Old Password'}</label>
                                                    <input className="form-control"
                                                        type="password"
                                                        name="pass"
                                                        value={pass}
                                                        onChange={e => setPass(e.target.value)}
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label">{'New Password'}</label>
                                                    <input className="form-control"
                                                        type="password"
                                                        name="pass1"
                                                        value={pass1}
                                                        onChange={e => setPass1(e.target.value)}
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label">{'Confirm New Password'}</label>
                                                    <input className="form-control"
                                                        type="password"
                                                        name="pass2"
                                                        value={pass2}
                                                        onChange={e => setPass2(e.target.value)}
                                                        required />
                                                </div>
                                                <div className="form-group form-row mt-3 mb-0">
                                                    <button className="btn btn-primary btn-block" type="button" onClick={resetPassword}>Save</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- login page end--> */}
            </div>
        </div>
    </div>
}

export default ResetPassword;